import React from "react";
import css from "./Toolbar.module.css";
import Logo from "../../Logo/Logo";
import NavigationItems from "../NavigationItems/NavigationItems";
import ToggleMenu from "../../Navigation/NavigationItems/NavigationItem/ToggleMenu";
import { Link } from "wouter";     // ← kept from HEAD

const Toolbar = (props) => (
  <header className={css.Toolbar}>
    
    {/* Side menu toggle icon */}
    <ToggleMenu openMenu={props.openMenu} />

    {/* Mobile Title */}
    <span className={css.mobileHead}>
      <h5>REC Student Portal</h5>
    </span>

    {/* Logo */}
    <Logo height="80%" />

    {/* Desktop Title with link to home */}
    <Link href="/">
      <span className={css.desktopHead}>
        <h5>REC Student Portal</h5>
      </span>
    </Link>

    {/* Desktop Navigation */}
    <nav className={css.DesktopOnly}>
      <NavigationItems />
    </nav>

  </header>
);

export default Toolbar;
